/**
 * Slugifies a movie title for use in a URL path segment, e.g. for /program/film/[slug].
 * A literal hyphen in the title (e.g. "Spider-Man", "AUTISME-mor") is escaped to an
 * underscore first, so that the hyphens introduced below always mean "this was a space" -
 * without that, deslugifyTitle can't tell the two apart and reconstructs the wrong title.
 * Everything else (colons, exclamation marks, Nordic/accented letters, etc.) is kept as-is.
 * The caller is responsible for percent-encoding the result (e.g. with encodeURIComponent)
 * when building an href, since punctuation like ":" or "/" is not safe to put directly into
 * a URL path segment.
 */
export function slugifyTitle(title: string): string {
    return title
        .toLocaleLowerCase()
        .trim()
        .replace(/-/g, "_")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
}

/**
 * Reverses slugifyTitle: hyphens become spaces, then the escaped underscores become hyphens
 * again. A literal underscore in the original title (very rare for a movie title, unlike a
 * hyphen) would incorrectly turn into a hyphen here - an acceptable tradeoff since this is
 * only used as a search parameter against the movieinfo API, not for display.
 */
export function deslugifyTitle(slug: string): string {
    return slug
        .replace(/-/g, " ")
        .replace(/_/g, "-")
        .trim();
}
